import React from "react";
import logo3 from "../../images/logo3.svg";
import { Link } from "react-router-dom";

// register-box

function Register() {
  return (
    <div>
      <div
        className="hold-transition register-page"
        style={{ backgroundColor: "rgb(17, 24, 39)" }}
      >
        <div
          className="register-box"
          style={{
            width: 800,
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundImage:
              "url('https://wallpaperaccess.com/full/187161.jpg')",
            backgroundSize: "cover",
            backgroundColor: "rgba(0,0,0,0.7)",
            backgroundBlendMode: "darken",
            borderRadius: 10,
            border: "2px solid #007bff",
            padding: 20,
          }}
        >
          <div
            style={{
              width: 450,
              padding: 25,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <h1
              style={{
                fontSize: 48,
                color: "#fff",
                fontFamily: "Arial",
                fontWeight: 700,
              }}
            >
              Welcome to <br />
              Admin Panel
            </h1>
            <p style={{ fontSize: 14, color: "#fff", fontFamily: "Arial" }}>
              This admin panel or a control panel is a system that enables
              administrators and workers to conduct various tasks like
              monitoring, maintaining, and controlling certain business
              processes.
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                marginTop:20
              }}
            >
              <div style={{display: "flex", flexDirection: "row",justifyContent: "flex-start",alignItems: "center",gap:5}}>
                <div >
                  <img className="cdsf"
                    src="assets/images/avatars/male-16.jpg"
                    style={{borderRadius:50}}
                  />
                </div>
                <div >
                  <img className="cdsf"
                    src="assets/images/avatars/male-09.jpg"
                    style={{borderRadius:50}}
                  />
                </div>
                <div >
                  <img className="cdsf"
                    src="assets/images/avatars/male-11.jpg"
                    style={{borderRadius:50}}
                  />
                </div>
                <div >
                  <img className="cdsf"
                    src="assets/images/avatars/male-07.jpg"
                    style={{borderRadius:50}}
                  />
                </div>
              </div>
              <div style={{color:"#BDBDBD",marginLeft:2}}>
                More than 17k people joined us, it's your turn
              </div>
            </div>
          </div>
          {/* /.login-logo */}
          <div
            className="card"
            style={{ width: 380, backgroundColor: "rgba(255,255,255,0.9)" }}
          >
            <div
              className="card-header text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={logo3} alt="logo" style={{ width: 200 }} />
            </div>
            <div className="card-body">
              <p className="login-box-msg">Register a new membership</p>
              <form action="../../index.html" method="post">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Full name"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-user" />
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope" />
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Retype password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8">
                    <div className="icheck-primary">
                      <input
                        type="checkbox"
                        id="agreeTerms"
                        name="terms"
                        defaultValue="agree"
                      />
                      <label htmlFor="agreeTerms">
                        I agree to the <a href="#">terms</a>
                      </label>
                    </div>
                  </div>
                  {/* /.col */}
                  <div className="col-4">
                    <button type="submit" className="btn btn-primary btn-block">
                      Register
                    </button>
                  </div>
                  {/* /.col */}
                </div>
              </form>
              <div className="social-auth-links text-center">
                <a href="#" className="btn btn-block btn-primary">
                  <i className="fab fa-facebook mr-2" />
                  Sign up using Facebook
                </a>
                <a href="#" className="btn btn-block btn-danger">
                  <i className="fab fa-google-plus mr-2" />
                  Sign up using Google+
                </a>
              </div>
              <Link to="/login" className="text-center">
                I already have a membership
              </Link>
            </div>
            {/* /.form-box */}
          </div>
          {/* /.card */}
        </div>
      </div>
    </div>
  );
}

export default Register;
